// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container principal avec marge pour la sidebar */
.contract-page {
  /* margin-left: 230px; */
  padding: 2rem;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%);
  font-family: "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

.contract-page h1 {
   color: #1e293b;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 2rem;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Barre d'outils */
.contract-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
  gap: 1rem;
  flex-wrap: wrap;
}

.contract-filter-input {
  flex: 1 1;
  min-width: 300px;
  padding: 0.875rem 1.25rem;
  border: 2px solid #e2e8f0;
  border-radius: 12px;
  font-size: 1rem;
  background: white;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.contract-filter-input:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
  transform: translateY(-1px);
}

.contract-filter-input::placeholder {
  color: #94a3b8;
}

/* Boutons */
.contract-btn-primary {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  border: none;
  padding: 0.875rem 1.5rem;
  border-radius: 12px;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
  white-space: nowrap;
}

.contract-btn-primary:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);
}

.contract-btn-primary:active {
  transform: translateY(0);
}

.contract-btn-secondary {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.25rem;
  border-radius: 8px;
  font-weight: 500;
  text-decoration: none;
  display: inline-block;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);
}

.contract-btn-secondary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
}

/* Tableau */
.contract-table {
  width: 100%;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  border-collapse: collapse;
}

.contract-table thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.contract-table thead th {
  padding: 1.25rem 1rem;
  text-align: left;
  font-weight: 600;
  color: white;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.contract-table tbody tr {
  border-bottom: 1px solid #f1f5f9;
  transition: all 0.2s ease;
}

.contract-table tbody tr:hover {
  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);
  transform: scale(1.01);
}

.contract-table tbody tr:last-child {
  border-bottom: none;
}

.contract-table tbody td {
  padding: 1rem;
  color: #374151;
  font-size: 0.875rem;
  vertical-align: middle;
}

/* Actions du tableau */
.contract-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: center;
}

.contract-actions button {
  background: none;
  border: none;
  padding: 0.5rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6b7280;
}

.contract-actions button:hover {
  background: #f3f4f6;
  transform: scale(1.1);
}

.contract-actions button:first-child:hover {
  color: #3b82f6;
  background: #dbeafe;
}

.contract-actions button:nth-child(2):hover {
  color: #f59e0b;
  background: #fef3c7;
}

.contract-actions button:last-child:hover {
  color: #ef4444;
  background: #fee2e2;
}

/* Modal */
.contract-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  backdrop-filter: blur(4px);
  animation: contract-modal-fade-in 0.3s ease;
}
.contract-modal-content-detaille{
  display: flex;
  flex-wrap: wrap;
  gap: 3rem ;
}

@keyframes contract-modal-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.contract-modal-content {
  background: white;
  border-radius: 20px;
  padding: 2rem;
  max-width: 900px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);
  animation: contract-modal-slide-up 0.3s ease;
}

@keyframes contract-modal-slide-up {
  from {
    transform: translateY(50px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.contract-modal-content h2,
.contract-modal-content h3 {
  color: #1a202c;
  margin-bottom: 1.5rem;
  font-weight: 700;
}

.contract-modal-content h4 {
  color: #4f46e5;
  margin-bottom: 1rem;
  font-weight: 600;
}

/* Grille de formulaire */
.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  margin-bottom: 2rem;
}

@media (max-width: 768px) {
  .form-grid {
    grid-template-columns: 1fr;
  }
}

.contract-form-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.contract-form-section-sec {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.contract-form-section label {
  font-weight: 600;
  color: #374151;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.contract-form-section input,
.contract-form-section select {
  padding: 0.875rem;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.2s ease;
  background: white;
}

.contract-form-section input:focus,
.contract-form-section select:focus {
  outline: none;
  border-color: #4f46e5;
  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
}

.contract-form-section input[readonly] {
  background: #f9fafb;
  color: #6b7280;
}

/* Formulaire client */
.contract-client-form {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  padding: 1.5rem;
  border-radius: 12px;
  border: 2px solid #e2e8f0;
  margin-top: 1rem;
  display: grid;
}

.contract-client-form input,
.contract-client-form select {
  margin-bottom: 1rem;
}

.contract-client-form button {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 100%;
}

.contract-client-form button:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);
}

/* Actions de modal */
.contract-modal-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  padding-top: 1.5rem;
  border-top: 1px solid #e5e7eb;
}

.contract-modal-actions button {
  padding: 0.875rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.contract-modal-actions button[type="submit"] {
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);
}

.contract-modal-actions button[type="submit"]:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);
}

.contract-modal-actions button[type="button"] {
  background: #f3f4f6;
  color: #374151;
}

.contract-modal-actions button[type="button"]:hover {
  background: #e5e7eb;
  transform: translateY(-1px);
}

.close-button {
  background: #f3f4f6 !important;
  color: #374151 !important;
}

.close-button:hover {
  background: #e5e7eb !important;
  transform: translateY(-1px);
}

/* QR Code dans la modal de visualisation */
.contract-modal-content canvas {
  margin: 1rem 0;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 1rem;
  background: white;
}

.contract-modal-content p {
  margin: 0.75rem 0;
  color: #374151;
  line-height: 1.6;
}

.contract-modal-content p b {
  color: #1f2937;
  font-weight: 600;
}

/* Responsive */
@media (max-width: 1024px) {
  .contract-page {
    margin-left: 0;
    padding: 1rem;
  }
}

@media (max-width: 768px) {
  .contract-toolbar {
    flex-direction: column;
    align-items: stretch;
  }

  .contract-filter-input {
    min-width: auto;
  }

  .contract-table {
    font-size: 0.75rem;
  }

  .contract-table thead th,
  .contract-table tbody td {
    padding: 0.75rem 0.5rem;
  }

  .contract-modal-content {
    padding: 1.5rem;
    margin: 1rem;
  }

  .contract-modal-actions {
    flex-direction: column;
  }
}

/* Animations pour les interactions */
.contract-table tbody tr,
.contract-btn-primary,
.contract-btn-secondary,
.contract-filter-input {
  will-change: transform;
}

/* Scrollbar personnalisée pour la modal */
.contract-modal-content::-webkit-scrollbar {
  width: 6px;
}

.contract-modal-content::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 3px;
}

.contract-modal-content::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 3px;
}

.contract-modal-content::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* États de chargement */
.contract-table tbody tr.loading {
  opacity: 0.6;
  pointer-events: none;
}

/* Focus visible pour l'accessibilité */
.contract-btn-primary:focus-visible,
.contract-btn-secondary:focus-visible,
.contract-filter-input:focus-visible {
  outline: 2px solid #4f46e5;
  outline-offset: 2px;
}

/* Style pour les champs désactivés */
.disabled-field-note {
  font-size: 0.75rem;
  color: #64748b;
  font-style: italic;
  font-weight: 400;
  margin-left: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/Contracts.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,wBAAwB;EACxB,aAAa;EACb,iBAAiB;EACjB,6DAA6D;EAC7D,uFAAuF;AACzF;;AAEA;GACG,cAAc;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,yCAAyC;EACzC,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;EAC5C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,eAAe;EACf,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,4DAA4D;EAC5D,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0BAA0B;EAC1B,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,eAAe;EACf,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,6DAA6D;EAC7D,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA,2CAA2C;AAC3C;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE;IACE,cAAc;IACd,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,qCAAqC;AACrC;;;;EAIE,sBAAsB;AACxB;;AAEA,0CAA0C;AAC1C;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA,uCAAuC;AACvC;;;EAGE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB","sourcesContent":["/* Container principal avec marge pour la sidebar */\n.contract-page {\n  /* margin-left: 230px; */\n  padding: 2rem;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f0f9ff 0%, #e0e7ff 100%);\n  font-family: \"Inter\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n.contract-page h1 {\n   color: #1e293b;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 2rem;\n  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* Barre d'outils */\n.contract-toolbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.contract-filter-input {\n  flex: 1;\n  min-width: 300px;\n  padding: 0.875rem 1.25rem;\n  border: 2px solid #e2e8f0;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: white;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.contract-filter-input:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n  transform: translateY(-1px);\n}\n\n.contract-filter-input::placeholder {\n  color: #94a3b8;\n}\n\n/* Boutons */\n.contract-btn-primary {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  color: white;\n  border: none;\n  padding: 0.875rem 1.5rem;\n  border-radius: 12px;\n  font-weight: 600;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n  white-space: nowrap;\n}\n\n.contract-btn-primary:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(79, 70, 229, 0.4);\n}\n\n.contract-btn-primary:active {\n  transform: translateY(0);\n}\n\n.contract-btn-secondary {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.25rem;\n  border-radius: 8px;\n  font-weight: 500;\n  text-decoration: none;\n  display: inline-block;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3);\n}\n\n.contract-btn-secondary:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);\n}\n\n/* Tableau */\n.contract-table {\n  width: 100%;\n  background: white;\n  border-radius: 16px;\n  overflow: hidden;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n  border-collapse: collapse;\n}\n\n.contract-table thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.contract-table thead th {\n  padding: 1.25rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: white;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.contract-table tbody tr {\n  border-bottom: 1px solid #f1f5f9;\n  transition: all 0.2s ease;\n}\n\n.contract-table tbody tr:hover {\n  background: linear-gradient(90deg, #f8fafc 0%, #f1f5f9 100%);\n  transform: scale(1.01);\n}\n\n.contract-table tbody tr:last-child {\n  border-bottom: none;\n}\n\n.contract-table tbody td {\n  padding: 1rem;\n  color: #374151;\n  font-size: 0.875rem;\n  vertical-align: middle;\n}\n\n/* Actions du tableau */\n.contract-actions {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: center;\n}\n\n.contract-actions button {\n  background: none;\n  border: none;\n  padding: 0.5rem;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6b7280;\n}\n\n.contract-actions button:hover {\n  background: #f3f4f6;\n  transform: scale(1.1);\n}\n\n.contract-actions button:first-child:hover {\n  color: #3b82f6;\n  background: #dbeafe;\n}\n\n.contract-actions button:nth-child(2):hover {\n  color: #f59e0b;\n  background: #fef3c7;\n}\n\n.contract-actions button:last-child:hover {\n  color: #ef4444;\n  background: #fee2e2;\n}\n\n/* Modal */\n.contract-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  backdrop-filter: blur(4px);\n  animation: contract-modal-fade-in 0.3s ease;\n}\n.contract-modal-content-detaille{\n  display: flex;\n  flex-wrap: wrap;\n  gap: 3rem ;\n}\n\n@keyframes contract-modal-fade-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.contract-modal-content {\n  background: white;\n  border-radius: 20px;\n  padding: 2rem;\n  max-width: 900px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.25);\n  animation: contract-modal-slide-up 0.3s ease;\n}\n\n@keyframes contract-modal-slide-up {\n  from {\n    transform: translateY(50px);\n    opacity: 0;\n  }\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.contract-modal-content h2,\n.contract-modal-content h3 {\n  color: #1a202c;\n  margin-bottom: 1.5rem;\n  font-weight: 700;\n}\n\n.contract-modal-content h4 {\n  color: #4f46e5;\n  margin-bottom: 1rem;\n  font-weight: 600;\n}\n\n/* Grille de formulaire */\n.form-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 2rem;\n  margin-bottom: 2rem;\n}\n\n@media (max-width: 768px) {\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.contract-form-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.contract-form-section-sec {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.contract-form-section label {\n  font-weight: 600;\n  color: #374151;\n  font-size: 0.875rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.contract-form-section input,\n.contract-form-section select {\n  padding: 0.875rem;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.2s ease;\n  background: white;\n}\n\n.contract-form-section input:focus,\n.contract-form-section select:focus {\n  outline: none;\n  border-color: #4f46e5;\n  box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);\n}\n\n.contract-form-section input[readonly] {\n  background: #f9fafb;\n  color: #6b7280;\n}\n\n/* Formulaire client */\n.contract-client-form {\n  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);\n  padding: 1.5rem;\n  border-radius: 12px;\n  border: 2px solid #e2e8f0;\n  margin-top: 1rem;\n  display: grid;\n}\n\n.contract-client-form input,\n.contract-client-form select {\n  margin-bottom: 1rem;\n}\n\n.contract-client-form button {\n  background: linear-gradient(135deg, #10b981 0%, #059669 100%);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  width: 100%;\n}\n\n.contract-client-form button:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3);\n}\n\n/* Actions de modal */\n.contract-modal-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  padding-top: 1.5rem;\n  border-top: 1px solid #e5e7eb;\n}\n\n.contract-modal-actions button {\n  padding: 0.875rem 1.5rem;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.contract-modal-actions button[type=\"submit\"] {\n  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);\n  color: white;\n  box-shadow: 0 4px 12px rgba(79, 70, 229, 0.3);\n}\n\n.contract-modal-actions button[type=\"submit\"]:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 16px rgba(79, 70, 229, 0.4);\n}\n\n.contract-modal-actions button[type=\"button\"] {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.contract-modal-actions button[type=\"button\"]:hover {\n  background: #e5e7eb;\n  transform: translateY(-1px);\n}\n\n.close-button {\n  background: #f3f4f6 !important;\n  color: #374151 !important;\n}\n\n.close-button:hover {\n  background: #e5e7eb !important;\n  transform: translateY(-1px);\n}\n\n/* QR Code dans la modal de visualisation */\n.contract-modal-content canvas {\n  margin: 1rem 0;\n  border: 2px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 1rem;\n  background: white;\n}\n\n.contract-modal-content p {\n  margin: 0.75rem 0;\n  color: #374151;\n  line-height: 1.6;\n}\n\n.contract-modal-content p b {\n  color: #1f2937;\n  font-weight: 600;\n}\n\n/* Responsive */\n@media (max-width: 1024px) {\n  .contract-page {\n    margin-left: 0;\n    padding: 1rem;\n  }\n}\n\n@media (max-width: 768px) {\n  .contract-toolbar {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .contract-filter-input {\n    min-width: auto;\n  }\n\n  .contract-table {\n    font-size: 0.75rem;\n  }\n\n  .contract-table thead th,\n  .contract-table tbody td {\n    padding: 0.75rem 0.5rem;\n  }\n\n  .contract-modal-content {\n    padding: 1.5rem;\n    margin: 1rem;\n  }\n\n  .contract-modal-actions {\n    flex-direction: column;\n  }\n}\n\n/* Animations pour les interactions */\n.contract-table tbody tr,\n.contract-btn-primary,\n.contract-btn-secondary,\n.contract-filter-input {\n  will-change: transform;\n}\n\n/* Scrollbar personnalisée pour la modal */\n.contract-modal-content::-webkit-scrollbar {\n  width: 6px;\n}\n\n.contract-modal-content::-webkit-scrollbar-track {\n  background: #f1f5f9;\n  border-radius: 3px;\n}\n\n.contract-modal-content::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 3px;\n}\n\n.contract-modal-content::-webkit-scrollbar-thumb:hover {\n  background: #94a3b8;\n}\n\n/* États de chargement */\n.contract-table tbody tr.loading {\n  opacity: 0.6;\n  pointer-events: none;\n}\n\n/* Focus visible pour l'accessibilité */\n.contract-btn-primary:focus-visible,\n.contract-btn-secondary:focus-visible,\n.contract-filter-input:focus-visible {\n  outline: 2px solid #4f46e5;\n  outline-offset: 2px;\n}\n\n/* Style pour les champs désactivés */\n.disabled-field-note {\n  font-size: 0.75rem;\n  color: #64748b;\n  font-style: italic;\n  font-weight: 400;\n  margin-left: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
